<div class="plugins-script-tag-container">
  <form [formGroup]="formGroup">
    <div class="header">
      <div class="header-title">
        <pdq-heading element="h5">Additional plugins</pdq-heading>
      </div>
      <pdq-slide-toggle
        formControlName="pluginsScriptTagEnabled"
        [disabled]="shop?.metadata?.pluginsScriptTagManuallyEnabed"
        [ignoreValueChangeOnToggle]="!formGroup.get('pluginsScriptTagEnabled').value"
        (onToggle)="handleToggle($event)"></pdq-slide-toggle>
    </div>

    <div class="content">Enable PDQ’s script to activate plugins (like Product Promise on PDP and Tracking Page).</div>
  </form>
</div>
